import { BASIC_CANDIDATE_FIELDS } from "./QuestionsMapping.constants";

/*
 * Maps and merges the open questions with the basic candidate fields
 */
export const buildMergedQuestions = (openQuestions) => {
  return [
    {
      label: "Candidate Fields",
      options: BASIC_CANDIDATE_FIELDS.map((field) => ({
        value: field.id,
        label: field.body
      }))
    },
    {
      label: "Open Questions",
      options: openQuestions.map((q) => ({
        value: q.id,
        label: q.body
      }))
    }
  ];
};
